import React, { useState } from 'react'
import styles from './forgot.module.css'
import '../../firebase'
import { auth } from '../../firebase'
import { sendPasswordResetEmail } from 'firebase/auth'
// import { Link } from 'react-router-dom'
const ForgotPassword = () => {
    const [email, setEmail] = useState()
    const [message, setMessage] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(email)
        sendPasswordResetEmail(auth, email)
            .then(res => {
                setMessage("Email Sent, Check Your email")
                console.log(res)
            })
            .catch(e => {
                setMessage("Please enter a Valid Email")
                console.log(e.message)
            })
    }

    return (
        <div className="register__content">
            <div className="left-content" id="left-content">
                <div className="top-part">
                    <h2>Let's Reconnect</h2>
                    <p>Alumni Association</p>
                </div>
                <div className="middle-content">

                </div>
                <div className="bottom-part">
                    {/* <h2>Not Registered yet?</h2> */}
                    {/* <Link className="register-btn btn btn-primary" style={{ "margin": "0px" }} aria-current="page" to="/register">Register</Link> */}

                    <h2>VIT AP</h2>
                    {/* <Link className="register-btn btn btn-primary" style={{"margin":"0px"}} aria-current="page" to="/register">Register</Link> */}
                    <p>A professional platform to connect, share and recreate wonderful memories with distinguished Alumni.</p>
                </div>

            </div>
            <div className="right-content">
                <div className="middle-content">
                    <h3>Forgot Password</h3>
                    <div className="form">
                        <form onSubmit={(e) => handleSubmit(e)} className={styles.rightSide}>
                            {
                                message.length > 0 && message === "Email Sent, Check Your email" ? <p className={styles.success}>{message}</p> : <p className={styles.error}>{message}</p>
                            }
                            <input type="email" required placeholder="Enter email *" onChange={(e) => setEmail(e.target.value)} />
                            <button className={styles.forgotBtn} >Send Link</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ForgotPassword